module.exports = "<div class=\"alert alert-warning\"> This part of the app is not yet fully usable. <ng-transclude></ng-transclude> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/elements/not-yet-fully-usable.html
// module id = 4198
// module chunks = 86